const AppraisalComparisonMapper = {
  toAppraisalViewRequests: (targetPracticeAreas, appraisalProgramYear) =>
    //TODO: MBRD-1323 request object needs to be updated to remove practice area from it.
    targetPracticeAreas.map(targetPa => ({
      includeHigherLevels: false,
      includeHigherProgramYears: false,
      practiceAreaId: targetPa.PracticeArea.Id,
      practiceGroupLevel: targetPa.PracticeGroup.Level,
      appraisalProgramYear: appraisalProgramYear
    }))
};

export default AppraisalComparisonMapper;
